import {Component, HostListener, Injectable, OnInit, ViewChild} from '@angular/core';
import {MenuItem} from "primeng/api";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslocoService} from "@ngneat/transloco";
import {ComponentCanDeactivate} from "../../common/can-deactivate/component-can-deactivate";
import {AccountDetailsComponent} from "./account-details/account-details.component";
import {AuthGuard} from "../../common/auth-guard.service";

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
@Injectable({
  providedIn: 'root'
})
export class AccountComponent implements OnInit, ComponentCanDeactivate {

  @ViewChild(AccountDetailsComponent)
  accountDetails: AccountDetailsComponent;

  public items: MenuItem[];
  public activeItem: MenuItem;

  public tabsVisible: boolean;

  private readonly navState: any;
  private activeItemIndex: number;


  constructor(private route: ActivatedRoute,
              private router: Router,
              private i18n: TranslocoService,
              private authGuard: AuthGuard) {
    this.tabsVisible = true;
    const navigation = this.router.getCurrentNavigation();
    this.navState = navigation?.extras.state;
  }

  ngOnInit(): void {
    if (this.authGuard.isECommerce()) {
      this.items = [
        {id: 'details', label: 'attribute.details', icon: 'pi pi-user'},
        {id: 'subscriptions', label: 'model.subscriptions', icon: 'pi pi-cloud-upload'},
        {id: 'faqs', label: 'model.faqs', icon: 'pi pi-question'},
        {id: 'user-guide', label: 'model.userGuide', icon: 'pi pi-file-pdf'},
      ];
    } else {
      this.items = [
        {id: 'details', label: 'attribute.details', icon: 'pi pi-user'},
        {id: 'faqs', label: 'model.faqs', icon: 'pi pi-question'},
        {id: 'user-guide', label: 'model.userGuide', icon: 'pi pi-file-pdf'},
      ];
    }

    this.items.forEach(item => {
      this.i18n.selectTranslate(item.label).subscribe(value => {
        this.itemsChanged();
        item.label = value;
      });
    });

    if (this.navState?.showView) {
      this.activeItemIndex = this.items.indexOf(this.items.filter(item => item.id === this.navState.showView)[0]);
      this.activeItem = this.items[this.activeItemIndex];
    } else {
      this.activeItemIndex = 0;
      this.activeItem = this.items[this.activeItemIndex];
    }
  }

  activateMenu(tab): void {
    this.activeItem = tab.activeItem;
    this.activeItemIndex = this.items.indexOf(this.activeItem);
  }

  itemsChanged(): void {
    this.tabsVisible = false;
    setTimeout(() => this.tabsVisible = true, 0);
  }

  @HostListener('window:beforeunload')
  canDeactivate(): boolean {
    return !this.accountDetails || this.accountDetails.formSuccess ||
      (this.accountDetails.userForm.untouched && !this.accountDetails.subscriptionsChanged
      && this.accountDetails.selectedLanguage.langCode == this.accountDetails.user.language);
  }

}
